
export default {
  name: "CheckoutButton",
  data() {
    return {


    }
  },
  watch: {

  },
  methods: {
    onClick() {
    
      this.$emit("click");
    }
  }
};
